package api

import org.ssoft.common.type.BitMask

sealed class VisualRotaryMode(override val mask: Int) : BitMask {
    data object NONE : VisualRotaryMode(0)
    data object DYNAMIC_VISUALS : VisualRotaryMode(2)
    data object PRIMARY_VISUALS : VisualRotaryMode(4)
}